// Cross-fades the background images of an image banner while the banner's own
// heading and buttons stay put.

class BannerRotator extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.frames = Array.from(this.querySelectorAll('.banner__rotator-frame'));
    if (this.frames.length < 2) return;

    this.initialized = true;
    this.index = Math.max(
      this.frames.findIndex((frame) => frame.classList.contains('is-active')),
      0
    );
    this.speed = Math.max(parseInt(this.dataset.speed, 10) || 5000, 1000);

    this.onVisibilityChange = () => (document.hidden ? this.stop() : this.start());
    document.addEventListener('visibilitychange', this.onVisibilityChange);

    this.start();
  }

  disconnectedCallback() {
    this.stop();
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
  }

  start() {
    if (!this.timer) this.timer = setInterval(() => this.advance(), this.speed);
  }

  stop() {
    clearInterval(this.timer);
    this.timer = null;
  }

  // Clearing every frame first means exactly one is ever active, however the
  // markup or a previous cycle left things.
  advance() {
    this.frames.forEach((frame) => frame.classList.remove('is-active'));
    this.index = (this.index + 1) % this.frames.length;
    this.frames[this.index].classList.add('is-active');
  }
}

customElements.define('banner-rotator', BannerRotator);
